import { post } from '..';

const getAssetTickets = (assetId: string, locationId: string) => post(
  'assets/tickets/statistics',
  { assetId, locationId },
);

export default getAssetTickets;
